import React from "react";
import logo1 from "assets/images/pidm.png";
import logo2 from "assets/images/logo2.svg";
import logo3 from "assets/images/logo3.svg";
import logo4 from "assets/images/logo4.svg";
import logo5 from "assets/images/logo5.svg";
import logo6 from "assets/images/logo6.svg";
import logo7 from "assets/images/logo7.svg";
import logo8 from "assets/images/logo8.svg";
import logo9 from "assets/images/akpk.png";
import logo10 from "assets/images/logo10.svg";
import logo11 from "assets/images/logo11.svg";
import logo12 from "assets/images/paynet.svg";
import logo13 from "assets/images/housing.png";
import logo14 from "assets/images/sac.png";
import fmos from "assets/images/fmos-logo.png";
import { Col, Row } from "react-bootstrap";

const SubFooter = () => {
  const links = [
    {
      href: "http://www.pidm.gov.my/",
      imgSrc: logo1,
      alt: "Image 1",
    },
    {
      href: "http://www.ibfim.com/",
      imgSrc: logo2,
      alt: "Image 2",
    },
    {
      href: "http://www.smeinfo.com.my/",
      imgSrc: logo3,
      alt: "Image 3",
    },
    {
      imgSrc: logo4,
      alt: "Image 4",
    },
    {
      href: "https://www.mifc.com/",
      imgSrc: logo5,
      alt: "Image 5",
    },
    {
      href: "https://aibim.com/",
      imgSrc: logo6,
      alt: "Image 6",
    },
    // {
    //   href: "https://www.ofs.org.my/en/",
    //   imgSrc: logo7,
    //   alt: "Image 7",
    // },
    {
      href: "https://www.paynet.my/",
      imgSrc: logo12,
      alt: "Image 12",
    },
    {
      href: "http://www.bnm.gov.my/",
      imgSrc: logo8,
      alt: "Image 8",
    },

    {
      href: "https://www.akpk.org.my/",
      imgSrc: logo9,
      alt: "Image 9",
    },
    {
      href: "https://www.fmos.org.my/en/",
      imgSrc: fmos,
      alt: "Image FMOS",
    },
    // {
    //   href: "https://www.sidrec.com.my/",
    //   imgSrc: logo10,
    //   alt: "Image 10",
    // },
    {
      href: "https://insuranceinfo.com.my/",
      imgSrc: logo11,
      alt: "Image 11",
    },

    {
      href: "https://www.housingwatch.my/",
      imgSrc: logo13,
      alt: "Image 13",
    },
    {
      href: "https://www.bnm.gov.my/shariah-advisory-council",
      imgSrc: logo14,
      alt: "Image 12",
    },
    // {
    //   href: "http://www.akpk.org.my/",
    //   imgSrc: "assets/img/image14.svg",
    //   alt: "Image 14",
    // },
    // Uncomment the next line if you want to include it
    // { href: "https://sidrec.com.my/", imgSrc: "assets/img/image15.svg", alt: "Image 15" },
  ];

  return (
    // <div className="container subfooter-container d-flex align-items-center justify-content-between">
    <div className="container subfooter-container ">
      <Row>
        <Col md={1}>
          <h5 className="mb-0 subfooter-title pb-3" data-translate="footer_6_3">
            Related Links:
          </h5>
        </Col>
        <Col md={11}>
          <div className="d-flex flex-wrap gap-3 justify-content-evenly">
            {links.map((link, index) => (
              <a
                className="footer-logo"
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                key={index}
              >
                <img
                  src={link.imgSrc}
                  alt={link.alt}
                  width="100%"
                  height={"100%"}
                  style={{
                    maxHeight: "31px",
                  }}
                />
              </a>
            ))}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SubFooter;
